import styled from "styled-components";
import { IoChevronDownOutline, IoChevronUpOutline } from "react-icons/io5";
import { colors } from "styles/variables";
import { TitleAndCategoryProps } from "./types";

export const AccordionCategoryDiv = styled.div<TitleAndCategoryProps>`
  background-color: ${(props) =>
    props.selectedBool ? colors.paleBlue : "white"};
  color: #595959;
  padding: 6px 0 6px 32px;
  font-weight: 400;
  font-size: 14px;

  &:hover {
    cursor: pointer;
  }
`;

export const TitleWrapper = styled.div<TitleAndCategoryProps>`
  background-color: ${(props) =>
    props.selectedBool ? colors.paleBlue : "white"};
  display: flex;
  color: #032287;
  font-weight: 400;
  font-size: 16px;
  padding: 5px 10px;
  align-items: center;
  justify-content: space-between;

  &:hover {
    cursor: pointer;
  }
`;

export const TitleDiv = styled.div`
  display: inline;
  font-size: 14px;
  
`;

export const StyledChevronUp = styled(IoChevronUpOutline)`
&&& {
  color="#595959"
  vertical-align: middle;
    cursor: pointer;
}
`;

export const StyledChevronDown = styled(IoChevronDownOutline)`
&&& {
  color="#595959"
  vertical-align: middle;
    cursor: pointer;
}
`;
